import translateFilter from '@/core/translation/translate.filter';
import * as z from 'zod';
import loggingService from '@/core/logging.service';

z.config({
    customError: (issue) => {
        if (issue.code === 'too_small' && issue.origin === 'string' && issue.minimum === 1) {
            return translateFilter('Validation.Required', '__field__');
        }
        if (issue.code === 'custom' && (issue.input === '' || issue.input === null)) {
            return translateFilter('Validation.Required', '__field__');
        }
        if (issue.code === 'too_small' && issue.origin === 'string') {
            return translateFilter('Validation.MinLength', issue.minimum as number, '__field__');
        }
        if (issue.code === 'too_big' && issue.origin === 'string') {
            return translateFilter('Validation.MaxLength', issue.maximum as number, '__field__');
        }
        if (issue.code === 'invalid_format' && issue.format === 'email') {
            return translateFilter('Validation.Email', '__field__');
        }
        if (issue.code === 'invalid_format' && issue.format === 'regex') {
            return translateFilter('Validation.Regex', '__field__');
        }
        if (issue.code === 'invalid_format' && issue.format === 'url') {
            return translateFilter('Validation.Url', '__field__');
        }
        if (issue.code === 'invalid_format' && issue.format === 'phone') {
            return translateFilter('Validation.Phone', '__field__');
        }
        if (issue.code === 'too_small' && issue.origin === 'array') {
            return translateFilter('Validation.Required', '__field__');
        }
        if (issue.code === 'invalid_type' && issue.expected === 'file') {
            // @ts-ignore
            if (issue.input?.length === 0) {
                return translateFilter('Validation.Required', '__field__');
            }
            return translateFilter('Product.Details.Report.FileUpload.Error.FileFormat', '__field__');
        }
        if (issue.code === 'invalid_type' && (issue.expected === 'boolean' || issue.expected === 'object')) {
            return translateFilter('Validation.Required', '__field__');
        }
        if (issue.code === 'custom' && issue.input === false) {
            return translateFilter('Validation.Required', '__field__');
        }
        if (issue.code === 'invalid_format' && issue.format === 'ipv4') {
            return translateFilter('Validation.IP4', '__field__');
        }
        loggingService.debug(`Mapping of Error not found. Code ${issue.code}. Format: ${issue.format}, origin: ${issue.origin}, expected: ${issue.expected}, message: ${issue.message}, input: ${issue.input}`);
        return undefined;
    }
});
